import { array, string } from 'fp-ts';
import { z } from 'zod';
import { CustomErrorParams, CustomErrorType } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const recipientEmailsSchema = z
    .string()
    .transform((emails) =>
        emails
            .split(';')
            .map(string.trim)
            .filter((email) => email !== '')
    )
    .superRefine((val, ctx) => {
        if (array.isEmpty(val)) {
            ctx.addIssue({
                code: z.ZodIssueCode.too_small,
                minimum: 1,
                inclusive: true,
                type: z.ZodParsedType.array,
            });
            return;
        }

        val.forEach((email) => {
            try {
                z.string().email().parse(email);
            } catch (error) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    params: {
                        errorType: CustomErrorType.Other,
                        textKey: TextKey.EnterpriseIntegrationSettingsInvalidEmailErrorMessage,
                        substitutes: { email },
                    } satisfies CustomErrorParams,
                });
            }
        });
    });
